export const en = {
  settings: 'settings',
  main_settings: 'main settings',
  navigation: 'navigation',
  colors: 'colors',
  help_descriptions: 'help descriptions',
  FAQs: "FAQ's",
  english_version_details: 'English Version Details',
  arabic_version_details: 'Arabic Version Details',
  data_settings: 'data settings',
  main_text_color: 'main text color*',
  secondary_text_color: 'secondary text color*',
  theme_primary_color: 'theme primary color*',
  charts_main_colors: 'charts main colors {{index}}',
  the_brand_name: 'The Brand Name ',
  default_language: 'Default Language ',
  are_you_sure_you_want_to_cancel_edit_release_notes:
    'Are you Sure you want to cancel editing the release notes? ',
  are_you_sure_you_want_to_cancel_add_release_notes:
    'Are you Sure you want to cancel adding the release notes? ',
  Timezone: 'Timezone ',
  utcTiming: 'UTC (Coordinated Universal Time)',
  name_error: 'This field is mandatory',
  question: 'Question',
  addquestion: 'Add Question',
  length_error: 'This field must be filled and be in range 2-500 character',
  identify_trending_countries: 'Identify Trending Countries',
  select_default_filter_for_countries: 'Select Default Filter For Countries',
  No_FAQs: 'No FAQs',
  reset_all_settings: 'Reset all settings',
  are_you_sure_you_want_to_reset_all_settings_to_default:
    'Are you sure you want to reset all settings to default ?',
  reset_successfully: 'Reset successfully',
  you_can_add_URL_link: 'You can add URL Link',
  time_format: 'Time Format',
  hour_time: '24-Hour time',
  trending_duration: 'Select Update Trending Duration',
  add_new_name: 'please add new Name',
  unique_new_name: 'the new name must be unique',
  enter_both: 'you have to enter both',
  user_settings: 'User settings',
  date_time: 'Date & Time',
  landing_page: 'Landing page',
  choose_your_landing_page: 'Choose your landing page',
  answer: 'answer',
  ad_answer: 'Add Answer',
  Link_Label: 'Link Label',
  Link_default: 'Link (Default)',
  administrative_settings: 'administrative settings',
  release_notes: 'Release notes',
  release_note: 'Release note',
  release_notes_settings: 'Release notes settings',
  release_notes_details: 'Release notes details',
  light_mode_colors: 'light mode colors',
  dark_mode_colors: 'dark mode colors',
  dark_main_text_color: 'main text color*',
  dark_secondary_text_color: 'secondary text color*',
  dark_theme_primary_color: 'theme primary color*',
  dark_charts_main_colors: 'charts main colors {{index}}',
  search_by_version: 'Search by version',
  modules: 'Modules',
  modules_in_release: 'Modules In Release',
  modules_included_in_release: 'Modules in Release',
  view_release_notes: 'View release notes',
};
export const ar = {
  dark_main_text_color: ' لون النص الرئيسي* ',
  dark_secondary_text_color: '  لون النص الثانوي*',
  dark_theme_primary_color: '  اللون الاساسي للموضوع*',
  dark_charts_main_colors: 'الرسوم البيانية بالألوان الرئيسية {{index}}',
  light_mode_colors: 'ألوان الوضع الفاتح',
  dark_mode_colors: 'ألوان الوضع الغامق',
  administrative_settings: 'الإعدادات الإدارية',
  settings: 'الإعدادات',
  main_settings: ' الإعدادات الرئيسية',
  navigation: 'التنقُل',
  colors: 'الألوان',
  help_descriptions: 'أوصاف المساعدة',
  FAQs: 'الاسئلة شائعة',
  data_settings: 'بيانات الإعدادات',
  main_text_color: ' لون النص الرئيسي* ',
  secondary_text_color: '  لون النص الثانوي*',
  theme_primary_color: '  اللون الاساسي للموضوع*',
  charts_main_colors: 'الرسوم البيانية بالألوان الرئيسية {{index}}',
  chart_1_main_color: 'أول لون رئيسي للرسوم البيانية',
  chart_2_main_color: 'ثاني لون رئيسي للرسوم البيانية',
  chart_3_main_color: 'ثالث لون رئيسي للرسوم البيانية',
  chart_4_main_color: 'رابع لون رئيسي للرسوم البيانية',
  chart_5_main_color: 'خامس لون رئيسي للرسوم البيانية',
  the_brand_name: 'اسم العلامة التجارية ',
  default_language: 'اللغة الافتراضية ',
  Timezone: 'وحدة زمنية ',
  utcTiming: 'UTC (التوقيت العالمي المنسق)',
  name_error: 'هذا الحقل إلزامي',
  question: 'السؤال',
  1: 'الاول',
  2: 'الثانى',
  3: 'الثالث',
  4: 'الرابع',
  5: 'الخامس',
  6: 'السادس',
  7: 'السابع',
  8: 'الثامن',
  9: 'التاسع',
  10: 'العاشر',
  addquestion: 'اضافه سؤال',
  length_error: 'يجب ملئ الحقل في نطاق ما بين 2-500 احرف ',
  identify_trending_countries: 'تحديد البلدان الترند ',
  select_default_filter_for_countries: 'حدد عامل التصفية الافتراضي للبلدان',
  No_FAQs: 'لا يوجد اسئلة شائعة',
  reset_all_settings: 'إعادة كل الإعدادات',
  are_you_sure_you_want_to_reset_all_settings_to_default:
    'هل أنت متأكد من أنك تريد إعادة تعيين جميع الإعدادات إلى الافتراضي؟',
  reset_successfully: ' تم إعادة تعيين بنجاح',
  you_can_add_URL_link: 'يمكنك إضافة رابط',
  time_format: 'تنسيق الوقت',
  hour_time: '24 ساعة',
  trending_duration: 'حدد مدة تحديث الترند',
  add_new_name: 'ادخل اسم جديد',
  unique_new_name: 'الاسم الجديد يجب ان لا يكون مكرر',
  enter_both: 'يجب ادخال العربيه و الانجلزيه',
  user_settings: 'إعدادات المستخدم',
  date_time: 'التاريخ والوقت',
  landing_page: 'الصفحة الرئيسية',
  choose_your_landing_page: 'اختر صفحتك المقصودة',
  answer: 'الإجابة',
  Link_Label: 'عنوان اللينك',
  ad_answer: 'أضف إجابة',
  Link_default: 'اللينك الافتراضي',
  english_version_details: 'تفاصيل النسخة الإنجليزية',
  arabic_version_details: 'تفاصيل النسخة العربية',
  release_notes: 'ملاحظات الإصدار',
  release_note: 'ملاحظة الإصدار',
  release_notes_settings: 'إعدادات ملاحظات الإصدار',
  release_notes_details: 'تفاصيل ملاحظات الإصدار',
  search_by_version: 'بحث بإسم الإصدار',
  modules: 'فروع',
  modules_in_release: 'الفروع في الإصدار',
  modules_included_in_release: 'الفروع في هذا الإصدار',
  are_you_sure_you_want_to_cancel_edit_release_notes:
    'هل انت متأكد انك تريد الغاء تعديل ملاحظات الإصدار ؟',
  are_you_sure_you_want_to_cancel_add_release_notes:
    'هل انت متأكد انك تريد الغاء إضافة ملاحظات الإصدار ؟',
  view_release_notes: 'عرض ملاحظات الإصدار',
};
